import React from 'react';
import '../styles/ProfileCard.css';

function ProfileCard({ name, title, imageSrc, description, email, linkedin, github }) {
  return (
    <section className="profile-card">
      <div className="card">
        <div className="avatar-team">
          <img src={imageSrc} alt={`${name}'s profile`} />
        </div>
        <div className="profile-info">
          <h2>{name}</h2>
          <h4>{title}</h4>
          <p>{description}</p>
          
          <div className="profile-social">
            {email && (
              <a href={`mailto:${email}`}>Email</a>
            )}
            {linkedin && (
              <a href={linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
            )}
            {github && (
              <a href={github} target="_blank" rel="noopener noreferrer">GitHub</a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProfileCard;